module.exports = __webpack_public_path__ + "img/clint-mckoy.03c43241.jpg";